// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"ff28075f","861":"5c2955ce"}[chunkId] + ".chunk.css";
};